import React, { useState } from "react";
import { ReactComponent as Arrow } from "../../../assets/novosicones/Financeiro/expand_more_black_24dp.svg";
import "./styles.scss";

const FooterAlertas = ({ tipo }) => {
  const [showAPagarFooter, setShowAPagarFooter] = useState(true);

  const [showBoletosFooter, setShowBoletosFooter] = useState(true);

  const handleShowAPagarFooter = () => {
    setShowAPagarFooter(!showAPagarFooter);
  };

  const handleShowBoletosFooter = () => {
    setShowBoletosFooter(!showBoletosFooter);
  };

  const estiloFooterVisible = {
    height: "auto",
    overflow: "visible",
    padding: "0 8px",
  };
  const estiloFooterHidden = {
    height: "0px",
    overflow: "hidden",
    padding: "0 8px",
  };

  return (
    <div className="centralized-column footerFinanceiroAlertas">
      {tipo == "aPagar" && (
        <div className="footerFinanceiroAlertas__container">
          <div
            className="centralized-space-between "
            onClick={handleShowAPagarFooter}
            style={
              showAPagarFooter
                ? { borderBottom: "2px solid #d1d1d1" }
                : { borderBottom: "none" }
            }
          >
            <p
            className="footerFinanceiroAlertas__container__modalBtn"
            >Legenda e notas de atenção</p>
            <Arrow
              style={
                showAPagarFooter
                  ? { transform: "rotate(-180deg)" }
                  : { transform: "rotate(0deg)" }
              }
            />
          </div>
          <div
            style={showAPagarFooter ? estiloFooterVisible : estiloFooterHidden}
          >
            <span className="footerFinanceiroAlertas__container__atencao">
              <b>Atenção:</b>
            </span>
            <p className="footerFinanceiroAlertas__container__fraseAlerta">
              - Se o boleto estiver disponível, aparecerá um ícone de código de
              barras a frente da parcela. Ao clicar neste ícone, é possível
              visualizar ou imprimir para pagamento.
            </p>
            <p className="footerFinanceiroAlertas__container__fraseAlerta">
              - Agrupamentos de parcelas podem ser visualizados na aba de resumo
              e é possível visualizar ou imprimir para pagamento.
            </p>
            <p className="footerFinanceiroAlertas__container__fraseAlerta">
              - Será possível a antecipação das parcelas com vencimento igual ou
              superior a 30 dias de antecedência.
            </p>
            <p className="footerFinanceiroAlertas__container__atencao">
              *Parcelas em atraso são destacadas com a cor vermelha
            </p>
          </div>
        </div>
      )}
      {tipo != "aPagar" && (
        <div className="footerFinanceiroAlertas__container">
          <div
            className="centralized-space-between "
            onClick={handleShowBoletosFooter}
            style={
              showBoletosFooter
                ? { borderBottom: "2px solid #d1d1d1" }
                : { borderBottom: "none" }
            }
          >
            <p
            className="footerFinanceiroAlertas__container__modalBtn"
            >Legenda e notas de atenção</p>
            <Arrow
              style={
                showBoletosFooter
                  ? { transform: "rotate(-180deg)" }
                  : { transform: "rotate(0deg)" }
              }
            />
          </div>
          <div
            style={showBoletosFooter ? estiloFooterVisible : estiloFooterHidden}
          >
            <span className="footerFinanceiroAlertas__container__atencao">
              <b>Atenção:</b>
            </span>
            <p className="footerFinanceiroAlertas__fraseAlerta">
              - Por aqui, você consulta boletos registrados pela empresa
              beneficiária. Se ele já está vencido, é possível atualizar os
              encargos e pagar no mesmo dia.
            </p>

            <p className="footerFinanceiroAlertas__fraseAlerta">
              - Boletos gerados pela central de relacionamento levam até 24
              horas para ser disponibilizados no Portal do Cliente.
            </p>
            <p className="footerFinanceiroAlertas__container__atencao">
              *Parcelas em atraso são destacadas com a cor vermelha
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default FooterAlertas;
